__turbopack_context__.v({
  "component": "style-module-scss-module__QrFwka__component",
  "wrapper": "style-module-scss-module__QrFwka__wrapper",
});
